import {IComponentOptions, ILogService} from "angular";
import {IModalService} from "angular-ui-bootstrap";
import {StateService} from "@uirouter/angularjs";
import {Application} from "../../../shared/model/Application";
import "./drafts-table.less";
import {IDescriptionFilter} from "../../../shared/reference-data/description.filter";

class DraftsTableController {

    public onSelect: any;
    public admin: boolean;
    public drafts: Application[];
    public sortBy: string;
    public sortByOrder: string;
    public sortReverse: boolean;
    public defaultSortBy: string;
    public defaultSortByOrder: string;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private $uibModal: IModalService,
                private descriptionFilter: IDescriptionFilter) {
    }

    public $onInit() {
        this.$log.debug("ApplicationsTableController.$onInit: %o", this.admin);
        this.defaultSortBy = "updated";
        this.defaultSortByOrder = "-updated";

        this.setDefaultSortOrder();

        if (this.drafts) {
            this.drafts.forEach((draft) => {
                this.$log.warn(draft);
                draft.descriptiveStatus = this.descriptionFilter(draft.status, "StudentCreditApplicationStatus");
            });

        }
    }

    public select(application: Application) {
        this.$log.debug("select", application.id);

        this.onSelect({
            $event: {
                applicationId: application.id,
                application: application
            }
        });
    }

    public deleteDraft(draft) {
        this.$log.debug("deleteDraft:", draft);
        this.$uibModal.open({
            component: "deleteDraftModal",
            resolve: {
                draft: () => draft
            }
        }).result.then((deletedDraft) => {
            draft = deletedDraft;
        }, (reason) => {
            this.$log.info("modal dismissed: " + reason);
        });
    }

    public setSortBy(sortBy: string) {
        if (this.sortBy === "descriptiveStatus" && this.sortBy === sortBy) {
            // User selected to sort by status second time. Switch to default sort order
            this.setDefaultSortOrder();
        } else if (this.sortBy === "created" && this.sortBy === sortBy) {
            if (!this.sortReverse) {
                // User selected sort by 'created' for second time - reverse the sort order
                this.sortReverse = true;
            } else {
                // User selected sort by 'created' for third time - reset to default sort
                this.setDefaultSortOrder();
            }

        } else {
            this.sortBy = sortBy;
            this.sortReverse = false;
        }

        this.sortByOrder = (!this.sortReverse ? "" : "-") + this.sortBy;
    }

    private setDefaultSortOrder() {
        this.sortBy = this.defaultSortBy;
        this.sortByOrder = this.defaultSortByOrder;
        this.sortReverse = true;
    }
}

export const DraftsTableComponent: IComponentOptions = {
    bindings: {
        drafts: "<",
        onSelect: "&",
        admin: "<?"
    },
    controller: DraftsTableController,
    template: require("./drafts-table.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/drafts-table/drafts-table.component.ts